/**
 * BAKIM BİTİŞ SAATİ — okunabilir hâli
 *
 * Bakım penceresi saatlerle ölçülüyor; aynı gün bitecekse tarih
 * yazmak gürültü. Gün atlıyorsa gün de yazılıyor, yoksa "03:40"
 * bekleyen öğrenci **hangi günün** 03:40'ı olduğunu bilemez.
 *
 * Saf modül: `Intl` çıktısı ortama göre değişiyor ve dal ayrımı
 * ("bugün mü") ancak sabit bir "şimdi" ile sınanabilir.
 */
export function bakimBitisMetni(iso: string, simdi = new Date()): string | null {
  const an = new Date(iso);
  if (Number.isNaN(an.getTime())) return null;

  const bicim = (secenek: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", ...secenek }).format(an);

  /*
    Gun karsilastirmasi YEREL gune gore — UTC ile degil. Sunucu UTC
    calisiyor ve gece yarisina yakin bir bakim penceresinde UTC gunu
    hala dun olabilir; o durumda ekran gereksiz yere tarih yazardi.
    Bu, bu depoda daha once gercek bir kusura yol acan sinif (C14.1).
  */
  const gun = (d: Date) =>
    new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", dateStyle: "short" }).format(d);

  const saat = bicim({ hour: "2-digit", minute: "2-digit" });
  return gun(an) === gun(simdi) ? saat : `${bicim({ day: "numeric", month: "long" })} ${saat}`;
}
